export default __webpack_public_path__ + "static/media/Scenario.29b6f7ea.svg";